import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-smooth-line-chart',
  templateUrl: './smooth-line-chart.component.html',
  styleUrl: './smooth-line-chart.component.scss'
})
export class SmoothLineChartComponent {
  @Input() set RiskTrendData(val: EChartsOption) {
    if (val) {
      this.chartOptions = val;
    }
  }

  chartOptions: EChartsOption;
  
}
